import { Route, Routes } from "react-router-dom";
import Login from "./pages/auth/Login";
import PrivateOutlet from "./pages/auth/PrivateOutlet";
import AuthorOutlet from "./pages/auth/AuthorOutlet";
import RouteCheck from "./pages/auth/RouteCheck";
import Home from "./pages/home";
import Donation from "./pages/donation";
import Advertise from "./pages/advertise";
import TestPair from "./pages/testPair";
import Payment from "./pages/authority/payment";
import PrayerTime from "./pages/authority/prayer";
import Logout from "./pages/auth/Logout";

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateOutlet />}>
        <Route path="" element={<RouteCheck />}>
          <Route path="/" element={<Home />} />
          <Route
            path="/donation/:donationId/:donationTitle"
            element={<Donation />}
          />
        </Route>
        <Route path="/advertise" element={<Advertise />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/payment/pair" element={<TestPair />} />
      </Route>
      <Route path="/" element={<AuthorOutlet />}>
        <Route path="/authority/payment" element={<Payment />} />
        <Route path="/authority/prayer-time" element={<PrayerTime />} />
      </Route>
    </Routes>
  );
}

export default App;
